//Package import
import { useState, useEffect, useReducer, useMemo } from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { createPortal } from 'react-dom'
// import { MultiSelect } from 'react-multi-select-component'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import uuid from 'react-uuid'
import SVG from 'react-inlinesvg'
import { useLazyQuery, useMutation } from '@apollo/client'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
// system imports
import closeSymbol from '../../../../../_metronic/images/closeSymbol.svg'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import { defaultDocsDetails } from '../addDocs/AddDocsInterface'
import DragDrop from '../../../../sharedComponent/UploadDrag'
import { alert, uploadFiles, getToken, } from '../../../../../utils/helper'
import { GET_SMART_DOCS_FILTERS, CREATE_SMART_DOCS, GET_SMART_DOCS_ID, GET_ALL_TAGS } from '../../../../../utils/GraphQLAPI'
import { GLOBAL_CONSTANTS } from '../../../../../utils/GlobalConstants'
import ToggleButton from '../../../../sharedComponent/ToggleButton'
import SmartDocsBestPractices from './SmartDocsBestPractices'
import PdfTagEditor from './PdfTagEditor'
import { Tag, eContractDeliveryTimeTypes } from '../addDocs/AddDocsInterface'
const MySwal = withReactContent(Swal)
type Props = {
  show: boolean
  handleClose: () => void
  method?: string
  editId?: string
  refetchDocs: () => void
  SetUp: string
}

type InputItem = {
  enum: string;
  [key: string]: any;
};

type FiltersState = {
  brandData: InputItem | null;
  language: InputItem | null;
  contractType: InputItem | null;
  customerType: InputItem | null;
  stateData: InputItem | null;
  utilityData: InputItem | null;
  commodityData: InputItem | null;
  productData: InputItem | null;
  eContractDeliveryTime: InputItem | any[] | null;
  logoData: InputItem | null;
  documentTypeId: InputItem | null;
};

type FiltersAction =
  | { type: "SET_FILTERS"; payload: Partial<FiltersState> }
  | { type: "RESET_FILTERS" };

const initialState: FiltersState = {
  brandData: null,
  language: null,
  contractType: null,
  customerType: null,
  stateData: null,
  utilityData: null,
  commodityData: null,
  productData: null,
  eContractDeliveryTime: null,
  logoData: null,
  documentTypeId: null,
};

export const defaultProductDetails = {
  documentName: "",
  documentTypeId: "",
  languageId: "",
  contractTypeId: "",
  customerTypeId: "",
  utilityId: "",
  commodityId: "",
  additionalInformation: "",
  documentS3Url: "",
  isActive: false,
  state: "",
  brandId: "",
  insertedProductIds: [],
  deleteProductIds: []
};


function filtersReducer(
  state: FiltersState,
  action: FiltersAction
): FiltersState {
  switch (action.type) {
    case "SET_FILTERS":
      return { ...state, ...action.payload };

    case "RESET_FILTERS":
      return initialState;

    default:
      return state;
  }
}


const fileUploadFileType = ['PDF']
const networkOnly = 'network-only'

const AddSmartDocsComponent = ({ handleClose, show, method, editId, refetchDocs, SetUp }: Props) => {
  const [status, setStatus] = useState<string>('Add')
  // const [selectedProduct, setSelectedProduct] = useState([])
  const [fileUrl, setFileUrl] = useState<string>('')
  const [EFL, setEFL] = useState<File | null>(null)
  const [activeStatus, setActiveStatus] = useState<any>(true)
  const modalsRoot = document.getElementById('root-modals') || document.body
  const [state, dispatch] = useReducer(filtersReducer, initialState);
  // const [editProductIds, setEditProductIds] = useState<string[]>([])
  const [showBestPractices, setShowBestPractices] = useState(false);
  const [showTagEditor, setShowTagEditor] = useState(false);
  const [tags, setTags] = useState<Tag[]>([]);
  const [buttonLoading, setButtonLoading] = useState(false);

  const extractPdf = async (
    pdfUrl: string,
    smartData?: string
  ): Promise<File> => {
    if (!pdfUrl) {
      throw new Error('PDF URL is missing');
    }
    let TOKEN: string;
    try {
      TOKEN = await getToken();
    } catch {
      throw new Error('Failed to get authentication token');
    }

    const res = await fetch(pdfUrl, {
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        Accept: 'application/pdf',
      },
    });

    if (!res.ok) {
      throw new Error(`Failed to fetch PDF: ${res.status} ${res.statusText}`);
    }

    const contentType = res.headers.get('content-type') || '';
    if (!contentType.toLowerCase().includes('application/pdf')) {
      throw new Error(`Invalid file type: ${contentType}`);
    }

    const blob = await res.blob();

    const safeFileName =
      smartData?.replace(/\s+/g, '') || 'document';

    return new File([blob], `${safeFileName}.pdf`, {
      type: 'application/pdf',
    });
  };

  useEffect(() => {
    if (!show) {
      setTags([])
      setEFL(null)
      setFileUrl('')
      // setSelectedProduct([])
      dispatch({ type: "RESET_FILTERS" })
    }
  }, [show])

  const [getCustomerData] = useLazyQuery(GET_SMART_DOCS_FILTERS, {
    onCompleted: (resData: any) => {
      dispatch({ type: "RESET_FILTERS" });
      const inputs = resData?.getAllInputValuesAtDocCreation;
      const constructed = inputs?.constructedInputs;
      dispatch({
        type: "SET_FILTERS",
        payload: {
          brandData: constructed?.find((item: InputItem) => item.enum === "BRAND")?.names || null,
          language: constructed?.find((item: InputItem) => item.enum === "LANGUAGE")?.names || null,
          contractType: constructed?.find((item: InputItem) => item.enum === "CONTRACT_TYPE")?.names || null,
          customerType: constructed?.find((item: InputItem) => item.enum === "CUSTOMER_TYPE")?.names || null,
          stateData: constructed?.find((item: InputItem) => item.enum === "STATE")?.names.filter((_: any, i: number) => i !== 0) || null,
          utilityData: constructed?.find((item: InputItem) => item.enum === "UTILITY")?.names || null,
          commodityData: constructed?.find((item: InputItem) => item.enum === "COMMODITY")?.names || null,
          // productData: inputs?.products || null,
          logoData: constructed?.find((item: InputItem) => item.enum === "LOGO")?.names || null,
          documentTypeId: constructed?.find((item: InputItem) => item.enum === "DOCUMENT_TYPE")?.names || null,
          eContractDeliveryTime: [
            { id: eContractDeliveryTimeTypes.AFTER_ENROLLMENT, value: 'After Enrollment' },
            { id: eContractDeliveryTimeTypes.AFTER_QC_APPROVED, value: 'After QC Approved' }
          ],
        },
      });
    },
    fetchPolicy: networkOnly,
  });

  const [getAllTags, { data: getTags }] = useLazyQuery(GET_ALL_TAGS)

  const [getSmartDocsById, { loading: isloading }] = useLazyQuery(GET_SMART_DOCS_ID, {
    fetchPolicy: networkOnly,
    variables: {
      id: editId,
    },
    onCompleted: async (SmartDocsData) => {
      // const products = SmartDocsData?.getSmartDocumentById?.smartDocProducts || []
      // setEditProductIds(products.map((p: any) => p.product.id))
      const smartData = SmartDocsData?.getSmartDocumentById
      setActiveStatus(smartData?.isActive)
      setFileUrl(smartData?.documentS3Url || '')
      if (!!smartData?.documentS3Url) {
        const pdfUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${smartData?.documentS3Url}`;
        try {
          const file = await extractPdf(pdfUrl, smartData.documentName)
          setEFL(file)
        }
        catch (error) {
          console.error('Error fetching PDF:', error)
          alert('Failed to load PDF document for preview', 'error')
        }
      }

      const editSmartDocsDetails = {
        DocumentType: smartData?.documentTypes?.documentType,
        DocumentTypeId: smartData?.documentTypes?.smartDocDetailsId,
        CustomerTypeId: smartData?.customerType?.id,
        CustomerType: smartData?.customerType?.name,
        State: smartData?.stateDetail?.name,
        StateId: smartData?.stateDetail?.id,
        Utility: smartData?.utility?.name,
        UtilityId: smartData?.utility?.id,
        documentName: smartData?.documentName,
        LanguageId: smartData?.language?.id,
        Language: smartData?.language?.languageName,
        ContractTypeId: smartData?.contractType?.id,
        ContractType: smartData?.contractType?.name,
        Commodity: smartData?.commodity?.name,
        CommodityId: smartData?.commodity?.id,
        additionalInformation: smartData?.additionalInformation,
        EContractDeliveryTimeId: smartData?.eContractDeliveryTime,
        EContractDeliveryTime: smartData?.eContractDeliveryTime === eContractDeliveryTimeTypes.AFTER_ENROLLMENT ? 'After Enrollment' : smartData?.eContractDeliveryTime === eContractDeliveryTimeTypes.AFTER_QC_APPROVED ? 'After QC Approved' : '',
      }
      formik.setValues({ ...editSmartDocsDetails })
    }
  })

  const coustomProductOptions = useMemo(
    () =>
      state?.productData?.map((item: any) => ({
        label: item.value,
        value: item.id,
      })) || [],
    [state?.productData]
  )

  // useEffect(() => {
  //   if (!editProductIds.length || !coustomProductOptions.length) return

  //   const selected = coustomProductOptions.filter((option: any) =>
  //     editProductIds.includes(option.value)
  //   )
  //   setSelectedProduct(selected)
  // }, [editProductIds, coustomProductOptions])

  useEffect(() => {
    if (method === 'Create') {
      formik.setValues({ ...defaultProductDetails })
      setStatus('Add')
    } else if (method === 'edit' || method === 'clone' || method === 'preview') {
      getSmartDocsById()
      setStatus(method === 'edit' ? 'Edit' : method === 'clone' ? 'Clone' : 'preview')
    }
    getAllTags()
    getCustomerData()
    formik.resetForm()
  }, [editId, method, show])

  const [addAndUpdateSmartDocs, { loading }] = useMutation(CREATE_SMART_DOCS, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
    onCompleted: () => {
      alert(`Smartdocs ${method === 'edit' ? 'updated' : 'added'} successfully `, 'success')
      handleClose()
      refetchDocs()
    },
    onError: (e) => {
      if (e.message.includes('null value in column "document_s3_url" of relation "smart_documents" violates not-null constraint')) {
        alert('You must go to the Configure Document Tags page and save the document before submitting the form.', 'error')
      }
      else {
        alert(e.message, 'error')
      }

    },
  })

  const basicValidations = {
    DocumentType: Yup.string().required('Document Type is required'),
    documentName: Yup.string().required('Document Name is required'),
    Language: Yup.string().required('Language is required'),
    EContractDeliveryTime: Yup.string().required('eContract Delivery Time is required'),

  }

  const formik: any = useFormik({
    initialValues: defaultDocsDetails,
    validationSchema: Yup.object().shape(basicValidations),
    enableReinitialize: true,
    onSubmit: async (values) => {
      const toNull = (val: any) =>
        val === "" || val === undefined ? null : val;
      // const currentSelectedIds = selectedProduct.map((p: any) => p.value)
      // const deleteProductIds = editProductIds.filter(
      //   (id) => !currentSelectedIds.includes(id)
      // )

      let payload = {
        data: {
          documentName: toNull(values.documentName),
          documentTypeId: toNull(formik.getFieldMeta('DocumentTypeId').value),
          languageId: toNull(formik.getFieldMeta('LanguageId').value),
          contractTypeId: toNull(formik.getFieldMeta('ContractTypeId').value),
          customerTypeId: toNull(formik.getFieldMeta('CustomerTypeId').value),
          utilityId: toNull(formik.getFieldMeta('UtilityId').value),
          commodityId: toNull(formik.getFieldMeta('CommodityId').value),
          additionalInformation: toNull(values.additionalInformation),
          documentS3Url: toNull(fileUrl),
          isActive: activeStatus,
          state: toNull(formik.getFieldMeta('StateId').value),
          // insertedProductIds: selectedProduct.map((val: any) => val.value),
          // deleteProductIds: deleteProductIds.map((id) => id),
          eContractDeliveryTime: toNull(formik.getFieldMeta('EContractDeliveryTimeId').value),
        }
      }
      if (method === 'Create' || method === 'clone') {
        if (!!fileUrl) {
          addAndUpdateSmartDocs(
            {
              variables: {
                id: '',
                ...payload
              }
            }
          )
        }
        else {
          alert('You must go to the Configure Document Tags page and save the document before submitting the form.', 'error')
        }
      }
      else if (method === 'edit') {
        addAndUpdateSmartDocs(
          {
            variables: {
              id: editId,
              ...payload
            }
          }
        )
      }
    }
  })
  useEffect(() => {
    if (!formik.isSubmitting) {
      return
    }
    if (Object.keys(formik.errors).length > 0) {
      const errorElement = document.getElementById(Object.keys(formik.errors)[0])
      errorElement?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      errorElement?.focus({ preventScroll: true })
    }
    if (!tags.length) {
      let errorlSmartDocs = document.getElementById('smartdocs')
      errorlSmartDocs?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      errorlSmartDocs?.focus({ preventScroll: true })
    }

  }, [formik, tags.length])

  const handleSelectedItem = (e: any, name: string) => {
    if (e.value.length > 0) {
      formik.setFieldValue(name, e.label)
      formik.setFieldValue(`${name}Id`, e.value)
    } else {
      formik.setFieldValue(name, '')
      formik.setFieldValue(`${name}Id`, null)
    }
  }
  const isDocumentNameFilled = Boolean(formik?.values?.documentName?.replace(/\s/g, ''));
  const handleFinishedTagging = async (finalFile: File) => {
    let FileUrl: string = ''
    try {
      FileUrl = await uploadFiles(
        [finalFile],
        false,
        '',
        `Productfiles/${formik?.values?.documentName.replace(/\s/g, '') || uuid()}`
      )
    } catch (error) {
      alert('Failed to upload modified document', 'error');
    } finally {
      setShowTagEditor(false);
    }
    setFileUrl(FileUrl[0]);
    if (!!FileUrl[0] && !!tags.length) {
      const pdfUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${FileUrl[0]}`;
      try {
        const file = await extractPdf(pdfUrl, formik?.values?.documentName?.replace(/\s/g, ''))
        setEFL(file)
      }
      catch (error) {
        console.error('Error fetching PDF:', error)
        alert('Failed to load PDF document for preview', 'error')
      }
    }
  };


  const removeDocs = () => {
    setFileUrl('')
    setEFL(null)
    setTags([])
  }

  return createPortal(
    <>
      <Modal
        id='kt-modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered mw-850px '
        show={show}
        onHide={() => handleClose()}
        backdrop={true}
      >
        <div className='modal-header'>
          <h2>{status} Document</h2>
          <div className='d-flex gap-5 align-items-center'>
            <ToggleButton
              leftText='Inactive'
              rightText='Active'
              leftTextClassName='badge-light-danger'
              rightTextClassName='badge-light-success'
              isActive={activeStatus}
              onChange={(checked) => setActiveStatus(checked)}
            />

            <div
              className="btn btn-sm btn-icon btn-light-primary"
              title="SmartDocs Best Practices"
              onClick={() => setShowBestPractices(true)}
            >
              ?
            </div>

            <div
              className='btn btn-sm btn-icon btn-active-color-primary'
              onClick={() => handleClose()}
            >
              <SVG src={closeSymbol}></SVG>
            </div>
          </div>
        </div>

        {!isloading ? <div className='hover-scroll-overlay-y mh-550px product-form'>
          <div className='mh-450px overflow-auto modal-body mx-10 ps-8 pe-2 py-0'>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Document Name</span>
                </label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Enter Document name'
                  id='documentName'
                  maxLength={51}
                  {...formik.getFieldProps('documentName')}
                />
                {formik.errors.documentName && formik.touched.documentName && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors.documentName}
                    </div>
                  </div>
                )}
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Document Type</span>
                </label>
                <Dropdown
                  fieldName='DocumentType'
                  optionList={state.documentTypeId}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
            </Row>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Language</span>
                </label>
                <Dropdown
                  fieldName='Language'
                  optionList={state.language}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Contract Type</span>
                </label>
                <Dropdown
                  fieldName='ContractType'
                  optionList={state.contractType}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
            </Row>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Customer Type</span>
                </label>
                <Dropdown
                  fieldName='CustomerType'
                  optionList={state.customerType}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>State</span>
                </label>
                <Dropdown
                  fieldName='State'
                  optionList={state.stateData}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
            </Row>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Utility</span>
                </label>
                <Dropdown
                  fieldName='Utility'
                  optionList={state.utilityData}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Commodity</span>
                </label>
                <Dropdown
                  fieldName='Commodity'
                  optionList={state.commodityData}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
            </Row>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              {/* <Col sm md lg={6}>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23'>Product Name</span>
              </label>
              <MultiSelect
                options={coustomProductOptions}
                value={selectedProduct}
                className='create-script-dropdown'
                onChange={setSelectedProduct}
                labelledBy='Select'
              />
            </Col> */}
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>eContract Delivery Time</span>
                </label>
                <Dropdown
                  fieldName='EContractDeliveryTime'
                  optionList={state.eContractDeliveryTime}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Additional Information</span>
                </label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Notes'
                  id='additionalInformation'
                  maxLength={51}
                  {...formik.getFieldProps('additionalInformation')}
                />
              </Col>
            </Row>

            {/* <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
            <Col sm md lg={6}>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23'>Add Logo</span>
              </label>
              <Dropdown
                fieldName='Logo'
                optionList={[]}
                handleSelectedItem={handleSelectedItem}
                formik={formik}
              />
            </Col>
          </Row> */}
            <div className='d-flex justify-content-between align-items-center mt-5 mb-3'>
              <div> <p className='fw-semibold fs-6 mt-3 required'>Document</p></div>
              <div>
                <div
                  className='cursor-pointer text-decoration-underline fs-7 fw-semibold text-ellipsis text-primary'
                  title="SmartDocs Best Practices"
                  onClick={() => setShowBestPractices(true)}
                >
                  Before uploading, review SmartDocs best practices.                </div>
              </div>
            </div>
            {EFL ? (
              <div
                className="d-flex gap-2 align-items-center"
                id="smartdocs"
              >
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setShowTagEditor(true)}
                >
                  Configure Document Tags
                </button>
                <button
                  type="button"
                  onClick={removeDocs}
                  className="btn p-0 text-danger fw-bold border-0 bg-transparent"
                  style={{ fontSize: "2.5rem" }}
                  title="Remove document"
                >
                  &times;
                </button>

                {/* {!fileUrl && method !== 'edit' && (
                  <div className='fv-plugins-message-container mt-2 w-100'>
                    <div
                      data-field='appname'
                      data-validator='notEmpty'
                      className='fv-help-block'
                    >
                      You must go to the Configure Document Tags page and save the document before submitting the form.
                    </div>
                  </div>
                )} */}
              </div>
            ) : (
              <DragDrop
                fileTypes={fileUploadFileType}
                setFile={setEFL}
                disabled={!isDocumentNameFilled}
                label={
                  isDocumentNameFilled
                    ? 'Click here to upload document or drag and drop'
                    : 'Enter document name to enable upload'
                }
              />
            )}
          </div>
          {EFL && (
            <PdfTagEditor
              show={showTagEditor}
              file={EFL}
              handleClose={() => setShowTagEditor(false)}
              onFinished={handleFinishedTagging}
              tagList={getTags}
              setTags={setTags}
              tags={tags}
              method={method}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
              SetUp={SetUp}
            />
          )}
          <div
            className='modal-footer sticky-bottom bg-white'
            style={{ borderRadius: '0 0 20px 20px', zIndex: '2' }}
          >
            <button
              type='button'
              className='btn btn-light'
              onClick={() => handleClose()}
            >
              Discard
            </button>
            {method !== 'preview' && <button
              className='btn btn-primary'
              data-kt-stepper-action='submit'
              disabled={loading}
              onClick={() => {
                if (!EFL) {
                  MySwal.fire({
                    customClass: { popup: 'swal2-border-radius' },
                    title: 'Document is required',
                    icon: 'warning',
                  })
                  return
                }

                formik.submitForm()
              }}
            >
              {method === 'Create'
                ? 'Creating docs'
                : 'Updating docs'}
              {loading && (
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              )}
            </button>}
          </div>

        </div>
          : <div className='d-flex justify-content-center align-items-center mh-550px'>
            <div className='spinner-border text-primary' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>}
      </Modal >
      <SmartDocsBestPractices setShowBestPractices={setShowBestPractices} showBestPractices={showBestPractices} />
    </>,
    modalsRoot
  )
}
export { AddSmartDocsComponent }